export const SET_PUBLIC_PRODUCT_SERVICE = (state, payload) => {
  state.publicProductService = payload;
};

export const SET_PRODUCTS_SERVICES_LIST = (state, payload) => {
  state.productsServicesList = payload.docs || [];
  state.productsServicesPagination = {
    total: payload.totalDocs || 0,
    page: payload.page || 1,
    limit: payload.limit || 20,
    totalPages: payload.totalPages || 1,
  };
};

export const SET_SELECTED_PRODUCT_SERVICE = (state, payload) => {
  state.selectedProductService = payload;
};

export const SET_MEMBER_PRODUCTS_SERVICES = (state, payload) => {
  state.memberProductsServices = payload || [];
};

export const UPDATE_SELECTED_PRODUCT_SERVICE_FIELD = (state, { field, value }) => {
  if (!state.selectedProductService) return;
  state.selectedProductService = {
    ...state.selectedProductService,
    [field]: value,
  };
};
